import React from 'react';
import { Link } from 'react-router-dom';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';

interface Article {
  title: string;
  url: string;
  imageUrl: string;
}

const articles: Article[] = [
  {
    title: 'How to create FREE WhatsApp QR Code for your Business',
    url: 'https://m.aisensy.com/blog/generate-free-whatsapp-qr-code',
    imageUrl: 'readmore1.png', // You'll need to add appropriate image
  },
  {
    title: '3 FREE Strategies to add WhatsApp to your Website',
    url: 'https://m.aisensy.com/blog/whatsapp-for-websites/',
    imageUrl: 'readmore2.png', // You'll need to add appropriate image
  },
  {
    title: 'Top 12 FREE WhatsApp Marketing Tools',
    url: 'https://m.aisensy.com/blog/free-whatsapp-marketing-tools/',
    imageUrl: 'readmore3.png', // You'll need to add appropriate image
  },
];

class ReadMore extends React.Component<Props> {
  render(): React.ReactElement {
    const { classes } = this.props;

    return (
      <section className={classes.readMore}>
        <div className={classes.title}>Related Resources</div>
        <div className={classes.articlesGrid}>
          {articles.map((article, index) => (
            <a
              key={index}
              href={article.url}
              className={classes.articleCard}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={classes.imageWrapper}>
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className={classes.articleImage}
                />
              </div>
              <h3 className={classes.articleTitle}>{article.title}</h3>
            </a>
          ))}
        </div>
      </section>
    );
  }
}

interface Props extends WithStyles<typeof styles> {}

const styles = (theme: Theme) =>
  createStyles({
    readMore: {
      // padding: theme.spacing(4),
      //   backgroundColor: '#40c057',
      //   color: 'white',
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
      },
    },
    title: {
      fontSize: '2.5rem',
      fontWeight: 'bold',
      marginBottom: theme.spacing(4),
      [theme.breakpoints.down('sm')]: {
        fontSize: '2rem',
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: '1.5rem',
      },
    },
    articlesGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: theme.spacing(4),
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
      },
    },
    articleCard: {
      background: 'white',
      borderRadius: theme.shape.borderRadius,
      border: '1px solid #e0e0e0',
      overflow: 'hidden',
      textDecoration: 'none',
      transition: 'transform 0.2s ease',
      '&:hover': {
        transform: 'translateY(-4px)',
      },
      backgroundColor: '#f9f9f9',
      // color: 'white',
    },
    imageWrapper: {
      aspectRatio: '16/9',
      overflow: 'hidden',
    },
    articleImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    articleTitle: {
      padding: theme.spacing(2),
      // color: 'white',
      fontSize: '1.25rem',
      fontWeight: 600,
    },
  });

export default withStyles(styles)(ReadMore);
